import React from "react";

function tooltip(tooltip) {
  if (tooltip) return <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={tooltip}></i>
  else return null
}

export const FormInfoLink = props => <>
  <label className="d-label">
    {tooltip(props.tooltip)}  <strong>{props.label}</strong>
  </label>
  <span className="pl-h">
    <a href={props.value} target="_blank">{props.label}</a>
  </span>
</>
